var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatelliteSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.921875,18.4921875l1.5061646-1.5061646c0.407959,0.0198364,0.8210449-0.1138306,1.1326294-0.425354 c0.5857544-0.5858154,0.5857544-1.5355835,0-2.1213379c-0.5858154-0.5858154-1.5355225-0.5858154-2.1213379,0 c-0.3115234,0.3115234-0.4451904,0.7246704-0.425354,1.1326294l-1.5061646,1.5061646l-6.4150391-6.4150391 C6.2402344,9.8085938,4.75,9.8085938,3.8974609,10.6621094c-2.4853516,2.4853516-3.8544922,5.5820312-3.8544922,8.7197266 c0,3.3583984,1.3076172,6.5166016,3.6826172,8.8925781c2.3759766,2.375,5.5341797,3.6826172,8.8925781,3.6826172 c3.1367188,0,6.2333984-1.3691406,8.71875-3.8535156C21.7646484,27.6767578,22,27.109375,22,26.5058594 c0-0.6044922-0.2353516-1.171875-0.6621094-1.5976562L14.921875,18.4921875z M19.9248047,26.6875 c-0.0009766,0-0.0009766,0.0009766-0.0009766,0.0009766c-2.1074219,2.1074219-4.7021484,3.2685547-7.3056641,3.2685547 c-2.8242188,0-5.4804688-1.0996094-7.4785156-3.0966797c-1.9970703-1.9980469-3.0966797-4.6542969-3.0966797-7.4785156 c0-2.6035156,1.1611328-5.1982422,3.2695112-7.3066406C5.375,12.0126953,5.4462891,12,5.4941406,12 c0.0488281,0,0.1201172,0.0126953,0.1835938,0.0761719l14.2470703,14.2470703C19.9873047,26.3857422,20,26.4570312,20,26.5058594 C20,26.5537109,19.9873047,26.625,19.9248047,26.6875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,0v2c7.7197266,0,14,6.2802734,14,14h2C32,7.1777344,24.8222656,0,16,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,5v2c4.9628906,0,9,4.0371094,9,9h2C27,9.9345703,22.0654297,5,16,5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10v2c2.2060547,0,4,1.7939453,4,4h2C22,12.6914062,19.3085938,10,16,10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatelliteSmall);
export default __webpack_public_path__ + "static/media/satellite--small.5ff0377addcf1e409853df0e26fe76fc.svg";
export { ForwardRef as ReactComponent };